export const LoginConstants = {
    CACHE_MFA_DATA: 'CACHE_MFA_DATA',
    SELECT_METHOD: 'SELECT_METHOD',
    REGISTER_CODE_SENT_AT: 'REGISTER_CODE_SENT_AT',
    CHANGE_STEP: 'CHANGE_STEP',
    RESET: 'RESET',
  };
   